export const DESTRUCTIVE_OUTLINE_COLORS =
  'border-transparent bg-destructive/10 text-destructive hover:bg-destructive/15 hover:border-transparent dark:text-red-400'

export const DESTRUCTIVE_OUTLINE_BUTTON = `border ${DESTRUCTIVE_OUTLINE_COLORS}`
